module.exports = __webpack_public_path__ + "img/Rectangle 21.1c04d8fa.png";